// Store UI global : etat ephemere de l'interface (drawer mobile, etc.).

import { defineStore } from "pinia";

interface UiState {
  sidebarOpen: boolean;
}

export const useUiStore = defineStore("ui", {
  state: (): UiState => ({ sidebarOpen: false }),

  actions: {
    toggleSidebar(): void {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar(): void {
      this.sidebarOpen = false;
    },
  },
});
